<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-btn disabled @click="$_truncateResources()">truncate resources</v-btn>
      <v-btn disabled @click="$_copyResources()">copy resources</v-btn>
      <v-btn disabled @click="$_checkCounts()">check count</v-btn>
      <v-btn disabled @click="$_updateRefs()">update refs</v-btn>
      <v-btn disabled @click="$_truncateReports()">truncate reports</v-btn>
      <v-btn disabled @click="$_copyReports()">copy reports</v-btn>

      <v-btn disabled @click="$_checkDatabase()">check database</v-btn>

      <v-btn disabled @click="$_updateReportRefs()">_updateReportRefs</v-btn>

      <v-btn disabled @click="$_updateReportRef()">_updateReportRef</v-btn>

      <v-btn disabled @click="$_copyPlugReports()">copy plug reports</v-btn>
    </v-flex>
    <v-flex xs12>
      <v-sheet>
        chargerCnt = {{chargerCnt.origin}} : {{chargerCnt.new}} : {{chargerCnt.ref}} <br>
        checkerCnt = {{checkerCnt.origin}} : {{checkerCnt.new}} : {{checkerCnt.ref}} <br>
        placeCnt = {{placeCnt.origin}} : {{placeCnt.new}} : {{placeCnt.ref}} <br>
        plugCnt = {{plugCnt.origin}} : {{plugCnt.new}} : {{plugCnt.ref}} <br>
      </v-sheet>
    </v-flex>
  </v-layout>
</template>

<script>
// import moment from 'moment/moment'

export default {
  name: 'DatabaseMigration',
  data () {
    return {
      chargerCnt: {origin: 0, new: 0, ref: 0},
      checkerCnt: {origin: 0, new: 0, ref: 0},
      placeCnt: {origin: 0, new: 0, ref: 0},
      plugCnt: {origin: 0, new: 0, ref: 0}
    }
  },
  created () {
    this.$emit('title', '데이터 마이그레이션')
  },
  methods: {
    $_truncateResources () {
      /*
      this.$fs.db().collection('chargers')
        .get().then(querySnapshot => {
          querySnapshot.forEach((doc) => {
            this.$fs.db()
              .collection('chargers')
              .doc(doc.id)
              .delete()
          })
        })

      this.$fs.db().collection('checkers')
        .get().then(querySnapshot => {
          querySnapshot.forEach((doc) => {
            this.$fs.db()
              .collection('checkers')
              .doc(doc.id)
              .delete()
          })
        })

      this.$fs.db().collection('places')
        .get().then(querySnapshot => {
          querySnapshot.forEach((doc) => {
            this.$fs.db()
              .collection('places')
              .doc(doc.id)
              .delete()
          })
        })

      this.$fs.db().collection('plugs')
        .get().then(querySnapshot => {
          querySnapshot.forEach((doc) => {
            this.$fs.db()
              .collection('plugs')
              .doc(doc.id)
              .delete()
          })
        })
        */
    },

    $_truncateReports () {
      /*
      this.$fs.db().collection('plug_reports')
        .get().then(querySnapshot => {
          querySnapshot.forEach((doc) => {
            this.$fs.db()
              .collection('plug_reports')
              .doc(doc.id)
              .delete()
          })
        })

      this.$fs.db().collection('reports')
        .get().then(querySnapshot => {
          querySnapshot.forEach((doc) => {
            this.$fs.db()
              .collection('reports')
              .doc(doc.id)
              .delete()
          })
        })
        */
    },

    async $_copyResources () {
      /*
      await this.$_copyChargers()
      await this.$_copyCheckers()
      await this.$_copyPlaces()
      await this.$_copyPlugs()
      */
    },

    $_copyChargers () {
      /*
      return new Promise((resolve, reject) => {
        this.$fs.db().collection('chargers_daejeon')
          .orderBy('managementNumber')
          .get().then((querySnapshot) => {
            this.chargerCnt.origin = querySnapshot.size
            this.chargerCnt.new = 0

            querySnapshot.forEach((doc) => {
              // console.log(`${doc.id} => ${doc.data()}`)

              var item = doc.data()

              this.$fs.db()
                .collection('chargers')
                .doc(doc.id)
                .set({...item, group: 'daejeon'})
                .then(() => {
                  ++this.chargerCnt.new
                })
                .catch(error => {
                  console.log(doc.id, error)
                })
              // console.log(doc.data())
            })

            resolve(querySnapshot.size)
          }).catch(error => {
            reject(error)
          })
      })
      */
    },

    $_copyCheckers () {
      /*
      return new Promise((resolve, reject) => {
        this.$fs.db().collection('checkers_daejeon')
          .orderBy('created')
          .get().then((querySnapshot) => {
            this.checkerCnt.origin = querySnapshot.size
            this.checkerCnt.new = 0

            querySnapshot.forEach((doc) => {
              // console.log(`${doc.id} => ${doc.data()}`)

              var item = doc.data()

              this.$fs.db()
                .collection('checkers')
                .doc(doc.id)
                .set({...item, group: 'daejeon'})
                .then(() => {
                  ++this.checkerCnt.new
                })
                .catch(error => {
                  console.log(doc.id, error)
                })
              // console.log(doc.data())
            })

            resolve(querySnapshot.size)
          }).catch(error => {
            reject(error)
          })
      })
      */
    },

    $_copyPlaces () {
      /*
      return new Promise((resolve, reject) => {
        this.$fs.db().collection('places_daejeon')
          .orderBy('created')
          .get().then((querySnapshot) => {
            this.placeCnt.origin = querySnapshot.size
            this.placeCnt.new = 0

            querySnapshot.forEach((doc) => {
              // console.log(`${doc.id} => ${doc.data()}`)

              var item = doc.data()

              this.$fs.db()
                .collection('places')
                .doc(doc.id)
                .set({...item, group: 'daejeon'})
                .then(() => {
                  ++this.placeCnt.new
                })
                .catch(error => {
                  console.log(doc.id, error)
                })
              // console.log(doc.data())
            })

            resolve(querySnapshot.size)
            console.log('places migration end ' + querySnapshot.size)
          }).catch(error => {
            reject(error)
          })
      })
      */
    },

    $_copyPlugs () {
      /*
      return new Promise((resolve, reject) => {
        this.$fs.db().collection('plugs_daejeon')
          .orderBy('created')
          .get().then((querySnapshot) => {
            this.plugCnt.origin = querySnapshot.size
            this.plugCnt.new = 0

            querySnapshot.forEach((doc) => {
              // console.log(`${doc.id} => ${doc.data()}`)

              var item = doc.data()

              this.$fs.db()
                .collection('plugs')
                .doc(doc.id)
                .set({...item, group: 'daejeon'})
                .then(() => {
                  ++this.plugCnt.new
                })
                .catch(error => {
                  console.log(doc.id, error)
                })
              // console.log(doc.data())
            })

            resolve(querySnapshot.size)
            console.log('plugs migration end ' + querySnapshot.size)
          }).catch(error => {
            reject(error)
          })
      })
      */
    },

    async $_updateRefs () {
      /*
      await this.$fs.db()
        .collection('chargers')
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var item = doc.data()

            if (item.placeRef) {
              const newRef = this.$fs.db().collection('places').doc(item.placeRef.id)
              this.$fs.db()
                .collection('chargers')
                .doc(doc.id)
                .set({placeRef: newRef}, {merge: true})
            }

            if (item.plugRef) {
              const newRef = this.$fs.db().collection('places').doc(item.plugRef.id)
              this.$fs.db()
                .collection('chargers')
                .doc(doc.id)
                .set({plugRef: newRef}, {merge: true})
            }
          })
        })

      await this.$fs.db()
        .collection('checkers')
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var item = doc.data()

            if (item.placeRefs) {
              const newRefs = []
              item.placeRefs.forEach(placeRef => {
                newRefs.push(this.$fs.db().collection('places').doc(placeRef.id))
              })

              this.$fs.db()
                .collection('checkers')
                .doc(doc.id)
                .set({placeRefs: newRefs}, {merge: true})
            }
          })
        })

      await this.$fs.db()
        .collection('places')
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var item = doc.data()

            if (item.chargerRefs) {
              const newRefs = []
              item.chargerRefs.forEach(chargerRef => {
                newRefs.push(this.$fs.db().collection('chargers').doc(chargerRef.id))
              })

              this.$fs.db()
                .collection('places')
                .doc(doc.id)
                .set({chargerRefs: newRefs}, {merge: true})
            }

            if (item.checkerRef) {
              const newRef = this.$fs.db().collection('checkers').doc(item.checkerRef.id)
              this.$fs.db()
                .collection('places')
                .doc(doc.id)
                .set({checkerRef: newRef}, {merge: true})
            }
          })
        })

      await this.$fs.db()
        .collection('plugs')
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            var item = doc.data()

            if (item.chargerRef) {
              const newRef = this.$fs.db().collection('chargers').doc(item.chargerRef.id)
              this.$fs.db()
                .collection('plugs')
                .doc(doc.id)
                .set({chargerRef: newRef}, {merge: true})
            }
          })
        })
        */
    },

    $_checkCounts () {
      /*
      this.$fs.db().collection('chargers_daejeon')
        .get().then((querySnapshot) => {
          const oldCnt = querySnapshot.size

          this.$fs.db()
            .collection('chargers')
            .get().then((querySnapshot) => {
              const newCnt = querySnapshot.size
              console.log('chargers count ', oldCnt === newCnt, oldCnt, newCnt)
            })
        })

      this.$fs.db().collection('checkers_daejeon')
        .get().then((querySnapshot) => {
          const oldCnt = querySnapshot.size

          this.$fs.db()
            .collection('checkers')
            .get().then((querySnapshot) => {
              const newCnt = querySnapshot.size
              console.log('checkers count ', oldCnt === newCnt, oldCnt, newCnt)
            })
        })

      this.$fs.db().collection('places_daejeon')
        .get().then((querySnapshot) => {
          const oldCnt = querySnapshot.size

          this.$fs.db()
            .collection('places')
            .get().then((querySnapshot) => {
              const newCnt = querySnapshot.size
              console.log('places count ', oldCnt === newCnt, oldCnt, newCnt)
            })
        })

      this.$fs.db().collection('plugs_daejeon')
        .get().then((querySnapshot) => {
          const oldCnt = querySnapshot.size

          this.$fs.db()
            .collection('plugs')
            .get().then((querySnapshot) => {
              const newCnt = querySnapshot.size
              console.log('plugs count ', oldCnt === newCnt, oldCnt, newCnt)
            })
        })

      this.$fs.db().collection('plug_reports_daejeon')
        .get().then((querySnapshot) => {
          const oldCnt = querySnapshot.size

          this.$fs.db()
            .collection('plug_reports')
            .get().then((querySnapshot) => {
              const newCnt = querySnapshot.size
              console.log('plug_reports count ', oldCnt === newCnt, oldCnt, newCnt)
            })
        })

      this.$fs.db().collection('reports_daejeon')
        .get().then((querySnapshot) => {
          const oldCnt = querySnapshot.size

          this.$fs.db()
            .collection('reports')
            .get().then((querySnapshot) => {
              const newCnt = querySnapshot.size
              console.log('reports count ', oldCnt === newCnt, oldCnt, newCnt)
            })
        })
        */
    },

    $_copyReports () {
      /*
      this.$fs.db().collection('plug_reports_daejeon')
        .get().then((querySnapshot) => {
          console.log('plug_reports migration start ' + querySnapshot.size)
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()

            if (item.chargerRef) {
              item.chargerRef = this.$fs.db().collection('chargers').doc(item.chargerRef.id)
            }

            if (item.placeRef) {
              item.placeRef = this.$fs.db().collection('places').doc(item.placeRef.id)
            }

            if (item.plugRef) {
              item.plugRef = this.$fs.db().collection('plugs').doc(item.plugRef.id)
            }

            this.$fs.db()
              .collection('plug_reports')
              .doc(doc.id)
              .set({...item, group: 'daejeon'})
            // console.log(doc.data())
          })
          console.log('plug_reports migration end ' + querySnapshot.size)
        }).catch(error => {
          if (error) {
            // TODO 오류 처리
            console.log(error)
          }
        })

      this.$fs.db().collection('reports_daejeon')
        .get().then((querySnapshot) => {
          console.log('reports migration start ' + querySnapshot.size)
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()

            if (item.chargerRef) {
              item.chargerRef = this.$fs.db().collection('chargers').doc(item.chargerRef.id)
            }

            if (item.placeRef) {
              item.placeRef = this.$fs.db().collection('places').doc(item.placeRef.id)
            }

            if (item.checkerRef) {
              item.checkerRef = this.$fs.db().collection('checkers').doc(item.checkerRef.id)
            }

            if (item.charger) {
              delete item.charger
            }

            if (item.place) {
              delete item.place
            }

            if (item.checker) {
              delete item.checker
            }

            const p1 = item.placeRef.get()
            const p2 = item.chargerRef.get()
            const p3 = item.checkerRef.get()

            Promise.all([p1, p2, p3]).then(([place, charger, checker]) => {
              // console.log(place.data(), charger.data(), checker.data())

              const data = {...item}
              if (place) {
                data['place'] = place.data()
              }

              if (charger) {
                data['charger'] = charger.data()
              }

              if (checker) {
                data['checker'] = checker.data()
              }

              return this.$fs.db()
                .collection('reports')
                .doc(doc.id)
                .set({
                  ...data,
                  group: 'daejeon'
                }, {merge: true})
            })

            // this.$fs.db()
            //  .collection('reports')
            //  .doc(doc.id)
            //  .set({...item, group: 'daejeon'})
            // console.log(doc.data())
          })

          console.log('reports migration end ' + querySnapshot.size)
        }).catch(error => {
          if (error) {
            // TODO 오류 처리
            console.log(error)
          }
        })
        */
    },

    $_checkDatabase () {
      /*
      this.$fs.db().collection('chargers_daejeon')
        .get().then((querySnapshot) => {
          console.log('chargers_daejeon count', querySnapshot.size)
          let i = 0

          querySnapshot.forEach(doc => {
            this.$fs.db()
              .collection('chargers')
              .doc(doc.id)
              .get()
              .then(d => {
                if (d.exists) {
                  // console.log(++i)
                } else {
                  console.log('charger', doc.id)
                }
              })
              .catch(error => {
                console.log('charger', doc.id, error)
              })
          })
        })

      this.$fs.db().collection('checkers_daejeon')
        .get().then((querySnapshot) => {
          console.log('checkers_daejeon count', querySnapshot.size)
          let i = 0

          querySnapshot.forEach(doc => {
            this.$fs.db()
              .collection('checkers')
              .doc(doc.id)
              .get()
              .then(d => {
                if (d.exists) {
                  // console.log(++i)
                } else {
                  console.log('checker', doc.id)
                }
              })
              .catch(error => {
                console.log('checker', doc.id, error)
              })
          })
        })

      this.$fs.db().collection('places_daejeon')
        .get().then((querySnapshot) => {
          console.log('places_daejeon count', querySnapshot.size)
          let i = 0

          querySnapshot.forEach(doc => {
            this.$fs.db()
              .collection('places')
              .doc(doc.id)
              .get()
              .then(d => {
                if (d.exists) {
                  // console.log(++i)
                } else {
                  console.log('place', doc.id)

                  this.$fs.db()
                    .collection('places')
                    .doc(doc.id)
                    .set({...doc.data(), group: 'daejeon'})
                    .then(() => {
                      // ++this.placeCnt.new
                    })
                    .catch(error => {
                      console.log(doc.id, error)
                    })
                }
              })
              .catch(error => {
                console.log('places', doc.id, error)
              })
          })
        })

      this.$fs.db().collection('plugs_daejeon')
        .get().then((querySnapshot) => {
          console.log('plugs_daejeon count', querySnapshot.size)
          let i = 0

          querySnapshot.forEach(doc => {
            this.$fs.db()
              .collection('plugs')
              .doc(doc.id)
              .get()
              .then(d => {
                if (d.exists) {
                  // console.log(++i)
                } else {
                  console.log('plugs', doc.id)

                  this.$fs.db()
                    .collection('plugs')
                    .doc(doc.id)
                    .set({...doc.data(), group: 'daejeon'})
                    .then(() => {
                      // ++this.placeCnt.new
                    })
                    .catch(error => {
                      console.log(doc.id, error)
                    })
                }
              })
              .catch(error => {
                console.log('plugs', doc.id, error)
              })
          })
        })
      */
      /*
      this.$fs.db().collection('plug_reports_daejeon')
        .get().then((querySnapshot) => {
          const oldCnt = querySnapshot.size

          this.$fs.db()
            .collection('plug_reports')
            .get().then((querySnapshot) => {
              const newCnt = querySnapshot.size
              console.log('plug_reports count ', oldCnt === newCnt, oldCnt, newCnt)
            })
        })

      this.$fs.db().collection('reports_daejeon')
        .get().then((querySnapshot) => {
          const oldCnt = querySnapshot.size

          this.$fs.db()
            .collection('reports')
            .get().then((querySnapshot) => {
              const newCnt = querySnapshot.size
              console.log('reports count ', oldCnt === newCnt, oldCnt, newCnt)
            })
        })
        */
    },

    $_updateReportRefs () {
      /*
      this.$fs.db()
        .collection('reports')
        .orderBy('charger', 'asc')
        .limit(200)
        .get().then((querySnapshot) => {
          querySnapshot.forEach(doc => {
            const report = doc.data()

            const p1 = report.placeRef.get()
            const p2 = report.chargerRef.get()
            const p3 = report.checkerRef.get()

            Promise.all([p1, p2, p3]).then(([place, charger, checker]) => {

              return this.$fs.db()
                  .collection('reports')
                  .doc(doc.id)
                  .set({
                  'place': place.data(),
                  'charger': charger.data(),
                  'checker': checker.data()
              }, {merge: true})

              console.log(place.data(), charger.data(), checker.data())
            })
            .catch(error => {
              if (error) {
                console.log(error)
              }
            })
          })
        })
        */
    },

    $_updateReportRef () {
      /*
      this.$fs.db()
        .collection('reports')
        .doc('bKXQqHeALQBKXpUcGxtq')
        .get().then((doc) => {
          console.log(doc)
          const report = doc.data()

          const p1 = report.placeRef.get()
          const p2 = report.chargerRef.get()
          const p3 = report.checkerRef.get()

          Promise.all([p1, p2, p3]).then(([place, charger, checker]) => {

            return this.$fs.db()
                .collection('reports')
                .doc(doc.id)
                .set({
                'place': place.data(),
                'charger': charger.data(),
                'checker': checker.data()
            }, {merge: true})

            console.log(place.data(), charger.data(), checker.data())
          })
          .catch(error => {
            if (error) {
              console.log(error)
            }
          })
        })
        */
    },

    $_copyPlugReports () {
      // const getRandomInt = (min, max) => {
      //   min = Math.ceil(min)
      //   max = Math.floor(max)
      //   return Math.floor(Math.random() * (max - min)) + min // 최댓값은 제외, 최솟값은 포함
      // }

      // this.$fs.db().collection('plug_reports')
      //   .where('created', '>=', moment('2021-10-25 00:00').toDate())
      //   .where('created', '<=', moment('2021-10-25 12:31').toDate())
      //   // .limit(1)
      //   .get().then((querySnapshot) => {
      //     console.log('plug_reports migration start ' + querySnapshot.size)
      //     querySnapshot.forEach((doc) => {
      //       // console.log(`${doc.id} => ${doc.data()}`)

      //       const fakeDate = moment(doc.data().created.toDate()).add(14, 'days').add(getRandomInt(60, 3600), 'seconds')

      //       console.log(`${doc.id} =>
      //         ${moment(doc.data().created.toDate()).format('YYYY-MM-DD HH:mm:ss')} =>
      //         ${fakeDate.format('YYYY-MM-DD HH:mm:ss')}`)
      //       //

      //       var item = doc.data()

      //       if (item.chargerRef) {
      //         item.chargerRef = this.$fs.db().collection('chargers').doc(item.chargerRef.id)
      //       }

      //       if (item.placeRef) {
      //         item.placeRef = this.$fs.db().collection('places').doc(item.placeRef.id)
      //       }

      //       if (item.plugRef) {
      //         item.plugRef = this.$fs.db().collection('plugs').doc(item.plugRef.id)
      //       }

      //       item.created = fakeDate.toDate()

      //       console.log(item)

      //       this.$fs.db()
      //         .collection('plug_reports')
      //         .add(item)
      //         .then((docRef) => {
      //           console.log('success', docRef)
      //         }).catch((error) => {
      //           console.error('Error adding document: ', error)
      //         })
      //     })
      //     console.log('plug_reports migration end ' + querySnapshot.size)
      //   }).catch(error => {
      //     if (error) {
      //       // TODO 오류 처리
      //       console.log(error)
      //     }
      //   })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/DatabaseMigration.vue